import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login'
import globalActions from './globalActions'
import globalMutations from './globalMutations'
import globalGetters from './globalGetters'
import parkingLot from './modules/parkingLot'
import userAdmin from './modules/userAdmin'
import violation from './modules/violation'
import reservation from './modules/reservation'
import personReservation from './modules/personReservation'
import personReservationConfig from './modules/personReservationConfig'
import letterReservation from './modules/letterReservation'
import mva from './modules/mva'
import wx from './modules/wx'
import pass from './modules/pass'
import reservationConfig from './modules/reservationConfig'
import vehicleRegister from './modules/vehicleRegister'
import passControl from './modules/passControl'
import personPassControl from './modules/personPassControl'
import messageManagement from './modules/messageManagement'
import charging from './modules/charging'
import pay from './modules/pay'
import park from './modules/park'
import message from './modules/message'
import iot from './modules/iot'
import school from './modules/school'
Vue.use(Vuex)
/**
 * store的最佳实践：1，使用module和namespaced
 * store的最佳实践：2，可以有global action，getters，mutation，但不能有全局state（可能会和module冲突），全局state转化为getters获取某个模块的私有states
 * store的最佳实践：3，在module的actions中调用接口，页面中的函数调用action，并传入页面未经处理数据信息，由actions转化并调用接口
 * store的最佳实践：4，store中只应存储多个组件/模块共享的state而不是组件内部私有的data
 * store的最佳实践：5，同步函数使用mutation or action ？ 仅涉及数据修改的使用mutation，涉及页面显示的（修改store中存储的控制页面的字段等）使用action，由action调用commit
 * store的最佳实践：6，一个模块调用另一个模块的action，最好在本模块创建同名action，由此action通过root调用另一个模块的action
 * store的最佳实践：7，一个模块引用另一个模块的state，最好在本模块建立同名getter，通过getter获取另一个模块的state
 * store的最佳实践：8，最好不要调用跨模块的mutation
 */

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  mutations: globalMutations,
  actions: globalActions,
  getters: globalGetters,
  modules: {
    login,
    parkingLot,
    userAdmin,
    violation,
    letterReservation,
    reservation,
    reservationConfig,
    mva,
    wx,
    pass,
    vehicleRegister,
    passControl,
    messageManagement,
    personReservation,
    personReservationConfig,
    charging,
    pay,
    park,
    personPassControl,
    message,
    iot,
    school
  },
  strict: debug,
})
